<template>
    <div id="metamaskWindow">
        <h2>Mushrooms! Please connect your metamask to continue!</h2>
        <button id="connectButton" @click="connect">Connect</button>
    </div>
</template>

<script>
export default {
    name: 'connect',
    props: {

    },
    data() {
        return {

        }
    },
    computed: {

    },
    methods: {
    async connect() {
        await this.$store.dispatch("connect", true);
    }
    } 
}
</script>

<style>
    #metamaskWindow {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 35%;
    height: 15%;
    padding-bottom: 5vh;
    padding-top: 3vh;
    padding-left: 5%;
    padding-right: 5%;
    margin-top: 12%;
    margin-left: auto;
    margin-right: auto;
    border-radius: 10px;
    background-color: white;
    filter: drop-shadow(10px 10px 15px rgba(14, 14, 14, 0.1));
    }

    #connectButton {
    width: 40%;
    height: 25%;
    font-family: rift-soft,sans-serif;
    font-weight: 600;
    font-style: normal;
    font-size: 24px;
    color: #ffffff;
    border: none;
    border-radius: 5px;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    background-color: rgb(255, 110, 64);
    transition: all .1s ease-out;
    }

    #connectButton:hover {
    transform: scale(1.02);
    }
</style>